import React, { useState, useEffect } from "react";
import moment from "moment";

import cube from "services/cube";
import { Form, Loading } from "components";

export function Benefits({ onChange, value, filters }) {
  const [benefits, setBenefits] = useState([]);
  const [loading, setLoading] = useState(true);

  const getParams = () => ({
    discount: (filters.discount && filters.discount.value) || null,
    campaign_id: (filters.campaign && filters.campaign.value) || null,
    date_start:
      filters.date_start !== null
        ? moment(filters.date_start).format("YYYY-MM-DD")
        : null,
    date_end:
      filters.date_end !== null
        ? moment(filters.date_end).format("YYYY-MM-DD")
        : null,
    channel_ids: filters.channels.length
      ? filters.channels.map((channel) => channel.value)
      : null,
    place_ids: filters.stores.length
      ? filters.stores.map((store) => store.value)
      : null,
    region_ids: filters.regions.length
      ? filters.regions.map((region) => region.value)
      : null,
  });

  useEffect(() => {
    if (!loading) {
      setLoading(true);
    }

    const params = getParams();

    cube
      .get("/list/benefits", { params })
      .then((response) => setBenefits(response.data))
      .catch((error) => console.error(error))
      .finally(() => setLoading(false));
  }, [filters]);

  return (
    <>
      <Form.Select
        placeholder="Todos"
        value={value}
        onChange={onChange}
        options={benefits.map((benefit) => ({
          value: benefit.id,
          label: benefit.title,
        }))}
      />
      {loading && <Loading type="filter" />}
    </>
  );
}
